import { render } from "./SalePos.vue?vue&type=template&id=46d2cd33"
import script from "./SalePos.vue?vue&type=script&lang=js"
export * from "./SalePos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__